import React from 'react'

const Capital = ({ height, modifiers }) => {
  return (
    <svg
      className={`icon icon-capital ${modifiers}`}
      xmlns="https://www.w3.org/2000/svg"
      viewBox="0 0 110 120"
      style={{height}}
    >
      <g className="icon-bg">
        <circle fill="none" cx="55" cy="81.2" r="38.8"></circle>
      </g>
      <g className="icon-capital__capital fill-lcs-gold-web-4">
        <path d="M69.5,45.2c-8.9-4-19.4-4.2-29.3-0.1c0.5-2.2,1.1-4.4,1.9-6c6.2-12.4,21.7-10.2,26.1,1.4
        C68.6,41.8,69,43.6,69.5,45.2z"></path>
      <path d="M75.3,55.3c-6.1-4.9-13.1-6.5-20.4-6.4c-7.4,0-14.4,1.5-20.3,6.3c-0.5-1.7,0.1-3,1.7-4.2c2.1-1.6,4.5-2.6,7-3.3
        c4-1.3,8.1-2.1,12.4-1.9c5.8,0.3,11.4,1.5,16.6,4.5c0.8,0.4,1.5,1,2.2,1.6C75.6,52.7,75.6,53.9,75.3,55.3z"></path>
      <path d="M78.5,72.4c-4.1-2.6-6.9-3.6-11.3-4.5c-4.9-1.1-9.9-1.5-14.9-1.2c-6.2,0.4-12.1,1.5-17.8,4.1
        c-1,0.5-2,1.2-2.9,1.8c-0.6-1.5-0.4-2.3,0.9-3.2c2.5-1.7,5.2-2.7,8-3.4c5.1-1.3,10.2-2.2,15.4-2.1c6.6,0.1,11.4,0.8,16.3,2.7
        c2.2,0.8,4.2,1.8,5.3,2.5C78.7,69.8,78.9,70.7,78.5,72.4z"></path>
      <path d="M74.4,59.1c0-0.3-0.2-0.6-0.4-0.8c-2.1-2.2-4.8-3.3-7.6-4.1c-5-1.5-10-2.2-15.2-1.6c-4.5,0.5-8.8,1.5-12.7,3.7
        c-1,0.6-2.4,1.4-2.6,2.3c-0.4,1.8-0.1,3.7-0.1,5.7c1-0.4,2-0.8,3-1.1v-2.7c0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2V62
        c1.6-0.4,3.2-0.7,4.9-0.9v-3c0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2v2.5c1.1-0.1,2.2-0.1,3.3-0.1c0.5,0,1.1,0,1.6,0.1v-2.5
        c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2v2.8c1.7,0.2,3.3,0.4,4.9,0.8v-1.2c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2v2.5
        c0.3,0.1,0.6,0.2,0.9,0.3c0.7,0.3,1.5,0.6,2.1,0.9l0,0C74.4,62.3,74.4,60.7,74.4,59.1z"></path>
      <g>
        <path d="M20.1,99.4c2,4.4,13.5,20.6,35,20.6c22.6,0,33-17.1,34.8-20.3l-3.8-3.3H23.4L20.1,99.4z"></path>
        <path d="M54.3,85.4c-3,1.3-5.9,2.6-8.9,3.9c-2.4,1.1-5,2.4-7.4,3.5h33.8c-5.4-2.6-10.8-5.2-16.2-7.5
          C55.2,85.2,54.7,85.3,54.3,85.4z"></path>
        <path d="M54.5,82.3c0.4-0.2,0.9-0.1,1.3,0.1c1.5,0.6,17.4,8.4,21.8,10.5h7c-0.5-0.9-1.4-2.4-1.4-2.4s-4.1-1-5.6-1.3
          c-0.1-2.5-0.2-4-0.2-6.4c0-2.1,0-4.3,0-6.4c0-0.8-0.4-1.4-1.4-2c-1-0.6-4.3-1.7-6.7-2.4c-4-1.2-8.2-1.7-12.4-1.8
          C51.5,70,46.3,70.6,41.2,72c-2.4,0.7-5.9,2.2-7.1,2.8s-1.4,1.2-1.4,2.4c0.1,3.9,0,8,0,12l-6.9,1.3c0,0-0.6,1.1-1.3,2.4h7.2
          C36.2,91,49.7,84.4,54.5,82.3z M68.8,78.3c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2v5.1c0,1.2-1,2.2-2.2,2.2c-1.2,0-2.2-1-2.2-2.2
          V78.3z M58.1,76c0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2v3.5c0,1.2-1,2.2-2.2,2.2s-2.2-1-2.2-2.2V76z M47.4,76c0-1.2,1-2.2,2.2-2.2
          c1.2,0,2.2,1,2.2,2.2v3.5c0,1.2-1,2.2-2.2,2.2c-1.2,0-2.2-1-2.2-2.2V76z M36.7,78.3c0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2v5.1
          c0,1.2-1,2.2-2.2,2.2s-2.2-1-2.2-2.2V78.3z"></path>
      </g>
      <path d="M57.9,27.7c0-0.3,0,0.1,0-1.4c0-0.2-0.3-2.1-1.8-2.7c-0.3-2.8-0.8-8.3-1.1-8.8c-0.5,2-0.7,6.2-0.9,8.8
        c-1.2,0.4-1.8,1.5-1.8,2.8c0,0.4,0,0.8,0,1C54.1,27.2,56,27.3,57.9,27.7z"></path>
      </g>
    </svg>
  )
}

Capital.defaultProps = {
  height: "9rem",
  modifiers: ""
}

export default Capital
